import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useToolbarHeight } from "@pepsico/layout";
import "mapbox-gl/dist/mapbox-gl.css";
import { MapProvider } from "react-map-gl/mapbox";

import { CogOrthoProvider } from "context/CogOrtho";
import { OrthoLodDebugProvider } from "context/OrthoLodDebug";
import { OrthoWorkflowProvider } from "context/OrthoWorkflow";
import { PlotMapProvider } from "context/PlotMap";
import { APP_TITLE } from "defs";

import MapOverlay from "./MapOverlay";
import PlotMapView from "./PlotMapView";

const PlotMap: React.FC = () => {
  const theme = useTheme();
  const toolbarHeight = useToolbarHeight();
  const isSmUp = useMediaQuery(theme.breakpoints.up("sm"));
  // Matches ContentArea / LeftNavBar closed drawer width.
  const closedDrawerWidth = isSmUp
    ? `calc(${theme.spacing(8)} + 1px)`
    : `calc(${theme.spacing(7)} + 1px)`;

  return (
    // PlotMapProvider: boundary/grid state. CogOrthoProvider: COG display
    // (location orthos, visibility, and open sessions). OrthoWorkflowProvider:
    // each flight from upload through analysis (reads CogOrtho's orthos).
    <PlotMapProvider>
      <CogOrthoProvider>
        <OrthoWorkflowProvider>
          <OrthoLodDebugProvider>
            <MapProvider>
              <title>{`${APP_TITLE} - Trial Map`}</title>
              <Box
                aria-label="Trial map"
                role="region"
                sx={{
                  // Same full-bleed approach as advancement-ui LocationsMap:
                  // cancel BaseView Container py:2 / gutters (spacing 3), size to viewport.
                  height: `calc(100vh - ${toolbarHeight}px)`,
                  margin: `${theme.spacing(-2)} ${theme.spacing(-3)}`,
                  overflow: "hidden",
                  position: "relative",
                  width: `calc(100vw - ${closedDrawerWidth})`,
                }}
              >
                <PlotMapView />
                <MapOverlay />
              </Box>
            </MapProvider>
          </OrthoLodDebugProvider>
        </OrthoWorkflowProvider>
      </CogOrthoProvider>
    </PlotMapProvider>
  );
};

export default PlotMap;
